// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81401b53","501":"6514d18a","925":"6249dcb7"}[chunkId] + ".chunk.js";
};